<template>
  <div class="m-paymentMethod" v-on:click="togglePayPal">
    <div class="m-paymentMethod--column">
      <div class="m-paymentMethod--rowSpaceBetween">
        <div class="m-paymentMethod--row">
          <div class="a-input-radio">
            <input type="radio" name="paymenttoken" class="a-input-radio__input" value="paypal" id="m-paymentMethod--paypal" />
            <div class="a-input-radio__check"></div>
          </div>
          <img v-bind:src="paymentsAssetUrl.paypal" class="pay-logo paypal"/>
        </div>
        <i :class="showPayPal ? 'far fa-angle-up' :'far fa-angle-down'" aria-hidden="true"></i>
      </div>
      <div v-show="showPayPal" class="m-paymentMethod-payPalForm">
        <label class="a-input-text__label">Log in to PayPal to continue</label>
        <div id="paypal-button"></div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * This component uses a rendered PayPal button from the `paypal-checkout` library
 * and integrates this into the Braintree JS SDK v3.
 *
 * Braintree JS SDK v3 PayPal dev guide:
 * https://developers.braintreepayments.com/guides/paypal/overview/javascript/v3
 *
 * Braintree JS SDK v3 PayPal checkout reference docs:
 * https://braintree.github.io/braintree-web/3.19.0/module-braintree-web_paypal-checkout.html#.create
 * https://braintree.github.io/braintree-web/3.19.0/PayPalCheckout.html
 *
 * PayPal Express Checkout integration guide
 * https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4/
 * Integrating PayPal Express Checkout with Braintree SDK
 * https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4/braintree-sdk/
 */
import paypal from 'paypal-checkout'
import BraintreePayPalCheckout from 'braintree-web/paypal-checkout'
import { mapState } from 'vuex'

export default {
  computed: mapState({
    paymentGatewayInfo: state => state.globalstate.paymentGatewayInfo,
    paymentsAssetUrl: state => state.globalstate.paymentsAssetUrl,
    cartHasSubscription: state => state.cart.isSubscription,
    cartCurrency: state => state.cart.currency,
    cartTotalAmount: state => state.cart.totalAmount
  }),
  props: ['clientInstance'],
  mounted () {
    this.createPayPalCheckout()
  },
  data () {
    return {
      showPayPal: false,
      nonce: '',
      paymentFlowTypes: {
        subscription: 'vault',
        nonSubscription: 'checkout'
      }
    }
  },

  methods: {
    collapsePayPal () {
      this.showPayPal = false
    },
    togglePayPal (event) {
      const element = document.getElementById('m-paymentMethod--paypal')
      // Let's not collapse this if you manage to click outside a control but inside the expanded LI
      if ((event.clientY - element.parentElement.getBoundingClientRect().top) <= 50) {
        if (this.showPayPal) {
          this.collapsePayPal()
        } else {
          this.showPayPal = true
          element.checked = true
          this.$emit('openPayPal')
        }
      }
    },
    createPayPalCheckout () {
      const vm = this // y god, pls end me. I thought we were past this JS
      BraintreePayPalCheckout.create(
        { client: this.clientInstance },
        (err, braintreePaypalCheckoutInstance) => {
          if (err) {
            // console.log(err)
            return
          } else {
            paypal.Button.render({
              env: this.paymentGatewayInfo.paypalEnvironment,
              commit: true,
              payment: (data, actions) => {
                // If the cart has a non-subscription product, we gotta use the checkout flow.
                if (!this.cartHasSubscription) {
                  return braintreePaypalCheckoutInstance.createPayment({
                    flow: this.paymentFlowTypes.nonSubscription,
                    amount: this.cartTotalAmount,
                    currency: this.cartCurrency,
                    intent: 'sale'
                  })
                }
                // ELSE just use the vault flow.
                return braintreePaypalCheckoutInstance.createPayment({
                  flow: this.paymentFlowTypes.subscription
                })
              },
              // For more style options see:
              // https://developer.paypal.com/docs/integration/direct/express-checkout/integration-jsv4/customize-button/#button-styles
              style: {
                shape: 'rect',
                color: 'gold',
                size: 'responsive',
                tagline: false,
                label: 'paypal'
              },
              onAuthorize: (data, actions) => {
                // Execute payment here.
                return braintreePaypalCheckoutInstance.tokenizePayment(data).then((payload) => {
                  let flow = this.paymentFlowTypes.subscription
                  if (!this.cartHasSubscription) {
                    flow = this.paymentFlowTypes.nonSubscription
                  }
                  vm.nonce = payload.nonce
                  vm.$emit('paypalAuthorized', true, flow)
                  vm.$store.dispatch('globalstate/fetch')
                })
              },
              onCancel: (data) => {
                console.log('checkout.js payment cancelled', JSON.stringify(data, 0, 2))
              },
              onError: (err) => {
                console.error(err)
              }
            }, '#paypal-button')
          }
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.m-paymentMethod-payPalForm {
  padding: 0.475em;
  @media all and (min-width: 1024px) {
    padding: 0.675em 1.875em;
  }
  .a-input-text__label {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// PayPal.vue?eec5a6fa